import { LevelType } from 'data/types';

export function isAddingHeatingOrCooling(level: LevelType | null): boolean {
  if (!level) return false;
  const heating = level.attributes.find((a) => a.code === 'heating');
  const cooling = level.attributes.find((a) => a.code === 'cooling');
  return (
    heating?.value === 'Primary' ||
    heating?.value === 'Supplemental' ||
    cooling?.value === 'Primary'
  );
}

export function isLevelConditioned(level: LevelType | null): boolean {
  if (!level) return true;
  return level.conditioned === true || isAddingHeatingOrCooling(level);
}

export function countsTowardFootprintSquareFootage(level: LevelType): boolean {
  if (level.type === 'crawlspace') {
    return false;
  }
  if (level.type === 'attic' || level.type === 'basement') {
    return isLevelConditioned(level);
  }
  return true;
}
